$(document).ready(function () {

    if ($('.slick-slidermittextoverlay').length) {
        $('.slick-slidermittextoverlay').each(function () {
            let slider = $(this);
            slider.slick({
                dots: true,
                arrows: false,
                fade: false,
                autoplay: false,
                slidesToShow: 1,
                centerMode: false,
                slidesToScroll: 1,
                infinite: false,
                appendArrows: slider.parent().find('.slick-arrows'),
                appendDots: slider.parent().find('.slick-dots-wrapper'),
                prevArrow: '<div class="slide-arrow prev-arrow"></div>',
                nextArrow: '<div class="slide-arrow next-arrow"></div>',
                autoplaySpeed: 3000
            });
        });
    }
});